export const DATA_DISTRIBUTION_URL = 'https://go.morningstar.com/LP=7137'
export const FULL_ACCESS = 'Full Access'
